import React from "react";
import { colors } from "./tokens";
import { InboxIcon } from "./icons";

export function EmptyState({ title, icon }: { title: string; icon?: React.ReactNode }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "56px 20px", gap: 12 }}>
      {icon || <InboxIcon />}
      <div style={{ fontSize: 13.5, color: colors.textMuted, fontWeight: 600 }}>{title}</div>
    </div>
  );
}

export function LoadingRow() {
  return <div style={{ textAlign: "center", padding: 48, color: colors.textMuted, fontSize: 13.5 }}>Chargement…</div>;
}
